<template>
    <a-list-item
        class="tower-card" :style="{ borderColor: color.primary }"
    >
        <a-list-item-meta>
            <Cover slot="avatar" v-bind="tower" />
            <div slot="description" class="tower-card-main"
                :style="{ background: `linear-gradient(90deg, transparent, ${ color.value + '1A' })` }"
            >
                <a :href="dashboardLink" target="_blank" class="mocking">
                    <a-row class="tower-card-header" type="flex">
                        <a-col>
                            <span class="author" title="作者">{{ tower.author }}</span>
                            <span v-if="tower.author2" title="复刻者">/{{ tower.author2 }}</span>
                        </a-col>
                        <a-col class="info-bar">
                            <span class="info-block info-block-people" title="游玩人数 / 通关人数">
                                <a-icon type="user" /><span>{{ tower.people }} / {{ tower.win }}</span>
                            </span>
                            <span class="info-block info-block-hot" title="热度 - 24小时内游玩量">
                                <a-icon type="fire" :theme="tower.hot > 99 ? 'filled' : 'outlined'"/>
                                <span>{{ hot }}</span>
                            </span>
                        </a-col>
                    </a-row>
                    <a-row class="tower-content">
                        <a-col>
                            <p v-html="tower.text"></p>
                        </a-col>
                    </a-row>
                </a>
                <a-row class="score-board">
                    <a-col>
                        <a-carousel arrows :dots="false">
                            <div slot="prevArrow" v-if="tops.length > 1"
                                class="custom-slick-arrow" style="left: 0;zIndex: 1"
                            >
                                <a-icon type="caret-left" />
                            </div>
                            <div slot="nextArrow" v-if="tops.length > 1"
                                class="custom-slick-arrow" style="right: 0"
                            >
                                <a-icon type="caret-right" />
                            </div>
                            <div v-for="top of tops" :key="top.ending">
                                <p>{{ top.ending ? top.ending + ':' : '' }} 当前max为 {{ top.score }}</p>
                                <p>最早由 {{ top.topuser }} 于 {{ formatDate(top.timestamp) }} 打出</p>
                            </div>
                        </a-carousel>
                    </a-col>
                </a-row>
                <a-row class="tag-list">
                    <a-col>
                        <a-tag color="red" v-if="intest">测试期</a-tag>
                        <a-tag v-for="tag of tags" :key="tag">{{ tag }}</a-tag>
                        <a-tag>{{ tower.floors }}层</a-tag>
                        <span class="comment-tag">
                            [<a :href="dashboardLink" target="_blank"><span :style="{ color:  color.primary }">{{ tower.comment }}</span>条评论</a>]
                        </span>
                    </a-col>
                </a-row>
            </div>
        </a-list-item-meta>
    </a-list-item>
</template>

<script>
import Cover from '@/components/Cover.vue'

import { COLORS } from '../constant'

export default {
    props: [ 'tower' ],
    computed: {
        color() {
            return COLORS[this.tower.color];
        },
        tags() {
            const tags = this.tower.tag.split("|");
            if (tags[tags.length-1] == "") tags.pop();
            return tags;
        },
        intest() {
            return Date.now() / 1000 - 172800 < this.tower.createTime;
        },
        tops() {
            if (!this.tower.tops) return [];
            const maxHard = this.tower.tops.reduce((r, t) => Math.max(r, t.hardCode), 0);
            return this.tower.tops
                .filter((e) => e.hardCode == maxHard && e.topuser)
                .sort((a, b) => b.timestamp - a.timestamp);
        },
        dashboardLink() {
            return `/tower/?name=${ this.tower.name }`
        },
        recommend() {
            return this.tower.hot >= 3000;
        },
        hot() {
            return this.recommend ? this.tower.hot - 3000 : this.tower.hot;
        },
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
    },
    components: {
        Cover
    }
}
</script>

<style lang="less" scoped>
.tower-card.ant-list-item {
    width: fit-content;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    border-left: 10px solid;
    border-bottom: none;
}
.ant-list-item-meta-avatar {
    margin-right: 0;
}
.tower-card-header {
    padding-top: 3px;
}
.info-bar {
    margin-left: auto;
    padding-right: 8px;
    .info-block {
        font-size: 13px;
        padding-left: 10px;
        display: inline-block;
        text-align: right;
        span {
            display: inline-block;
        }
    }
    .info-block-people {
        min-width: 88px;
        span {
            min-width: 72px;
        }
    }
    .info-block-hot {
        color: #e33e33;
        min-width: 40px;
        span {
            min-width: 24px;
        }
    }
}
.ant-list-item-meta-content {
    min-height: 150px;
    padding-left: 16px;
    .tower-content {
        margin-top: auto;
        height: 68px;
        width: 380px;
        p {
            font-size: 13px;
            margin-bottom: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin: 0;
        }
    }
    .author {
        color: rgba(0, 0, 0, 0.85);
    }
    .author2 {
        color: #6e6e6e;
    }
}
.ant-row {
    margin-right: 5px;
}
.tower-card-main {
    min-height: 150px;
}
.mocking {
    color: inherit;
}
.ant-carousel {
    width: 380px;
    height: 28px;
    p {
        margin-bottom: 0px;
        line-height: 13px;
    }
}
.tag-list {
    .ant-col {
        display: flex;
    }
    .comment-tag {
        margin-left: auto;
    }
    a {
        font-size: 13px;
        padding: 1px;
        color: inherit;
        span {
            font-weight: bold;
        }
    }
}
</style>

<style scoped>
/* For demo */
.ant-carousel >>> .slick-slide {
    text-align: center;
    height: 28px;
    overflow: hidden;
    font-size: 12px;
}
.ant-carousel >>> .custom-slick-arrow {
    width: 18px;
    height: 18px;
    font-size: 18px;
    color: inherit;
    opacity: 0.8;
}
.ant-carousel >>> .custom-slick-arrow:before {
    display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
    color: inherit;
    opacity: 1;
}
</style>